var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserpic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 7.49984C12.5001 8.88055 11.3808 9.99984 10.0001 9.99984C8.61934 9.99984 7.50005 8.88055 7.50005 7.49984C7.50005 6.11913 8.61934 4.99984 10.0001 4.99984C11.3808 4.99984 12.5001 6.11913 12.5001 7.49984Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 9.99984C18.3334 14.6022 14.6024 18.3332 10.0001 18.3332C5.39768 18.3332 1.66672 14.6022 1.66672 9.99984C1.66672 5.39746 5.39768 1.6665 10.0001 1.6665C14.6024 1.6665 18.3334 5.39746 18.3334 9.99984ZM3.33338 9.99984C3.33338 11.3905 3.75918 12.6817 4.48752 13.7502C5.9566 12.4534 7.88643 11.6665 10.0001 11.6665C12.1137 11.6665 14.0435 12.4534 15.5126 13.7502C16.2409 12.6817 16.6667 11.3905 16.6667 9.99984C16.6667 6.31794 13.6819 3.33317 10.0001 3.33317C6.31815 3.33317 3.33338 6.31794 3.33338 9.99984ZM10.0001 16.6665C8.30931 16.6665 6.76557 16.0371 5.59034 14.9998C6.76557 13.9626 8.30931 13.3332 10.0001 13.3332C11.6908 13.3332 13.2345 13.9626 14.4098 14.9998C13.2345 16.0371 11.6908 16.6665 10.0001 16.6665Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserpic);
export default __webpack_public_path__ + "static/media/userpic.74ec442440d3bed75c5b2ff2fdfa4a27.svg";
export { ForwardRef as ReactComponent };